<template>
    <div v-if="currentCountry">
        <img v-if="currentCountry.flagUrl"
             :src="currentCountry.flagUrl"
             :alt="`${currentCountry.countryName} flag`"
             class="h-[28px] w-[48px] cursor-pointer object-contain md:ml-10 md:mr-10"
             @click="goToCountrySelector">
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import contentApi from '@/project/content/api/contentApi';
import { CountryItem } from '@/api/content/models';
import { clearSelectedCountry } from '@/project/pages/countrySelector.utils';

export default defineComponent({
    name: 'CurrentCountryFlag',
    components: {
    },
    setup() {
        const currentCountry = ref<CountryItem | null>(null);

        contentApi.settings.then(settings => {
            const pathSegment = location.pathname.split('/')[1];
            currentCountry.value = pathSegment && settings.countries?.length
                ? settings.countries.find(c => c.path === pathSegment) ?? null
                : null;
        });

        function goToCountrySelector() {
            clearSelectedCountry();
            window.location.href = '/';
        }

        return {
            currentCountry,
            goToCountrySelector,
        };
    },
});
</script>

<style scoped>

</style>
